var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class LoginAuditApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'login-audit';
    }
    getEnvironments() {
        return __awaiter(this, arguments, void 0, function* (options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/environments` }, options));
        });
    }
    getLogs(environmentId_1) {
        return __awaiter(this, arguments, void 0, function* (environmentId, params = {}, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/${encodeURIComponent(environmentId)}/logs`, params }, options));
        });
    }
}
//# sourceMappingURL=index.js.map